export default __webpack_public_path__ + "static/emilylouie-abd1dd6b0e0623e13261292381fc5ff7.pdf";